import React from 'react';
import { 
  HiOutlineCamera, 
  HiOutlineShare, 
  HiOutlineEye, 
  HiOutlinePencil,
  HiOutlineMusicalNote,
  HiOutlineBars3 
} from 'react-icons/hi2';
import './ControlBar.css';

function ControlBar({ 
  onScreenshot, 
  onShare, 
  onMenuToggle, 
  galleryName,
  isViewMode,
  onViewModeToggle,
  isOwner,
  onHelp
}) {
  return (
    <>
      <button 
        className="menu-button"
        title="Menu"
        onClick={onMenuToggle}
      >
        <HiOutlineBars3 size={24} />
      </button>
      
      <div className="control-bar">
        <div className="control-bar-content">
          <button 
            className="control-button"
            onClick={onScreenshot}
            title="Take Screenshot"
          >
            <HiOutlineCamera size={22} />
          </button>
          <button 
            className="control-button"
            onClick={onShare}
            title="Share Gallery"
          >
            <HiOutlineShare size={22} />
          </button>
          {isOwner && (
            <button 
              className="control-button"
              onClick={onViewModeToggle}
              title={isViewMode ? "Switch to Edit Mode" : "Switch to View Mode"}
            >
              {isViewMode ? <HiOutlinePencil size={22} /> : <HiOutlineEye size={22} />}
            </button>
          )}
          <div className="control-separator" />
          <button 
            className="control-button"
            title="Toggle Music"
          >
            <HiOutlineMusicalNote size={22} />
          </button>
          <button 
            className="control-button help-button"
            onClick={onHelp || onMenuToggle}
            title="Help & FAQ"
          >
            <span className="help-icon">?</span>
          </button>
        </div>
      </div>
    </>
  );
}

export default React.memo(ControlBar); 